import React from 'react';

export default class CountBtn extends React.PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            num: 0
        };
    }
    componentDidMount() {
        const { type, num } = this.props;
        type !== 'code' && this.startTimer(num);
    }
    startTimer = (num, cb) => {
        this.setState({ num });
        this.timer = setInterval(() => {
            this.setState((preState) => {
                console.log('==', preState);
                if (preState.num - 1 <= 0) {
                    clearInterval(this.timer);
                    typeof cb === 'function' && cb();
                }
                return { num: preState.num - 1 };
            });
        }, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.timer);
    }
    clearTimer = () => {
        clearInterval(this.timer);
        this.setState({
            num: 0
        })
    }
    click = () => {
        const { onClick, isActive, type, onEnd, num: n, onStart } = this.props;
        const { num } = this.state;
        if (type === 'code') {
            if (num <= 0) {
                typeof onStart === 'function' && onStart();
                this.startTimer(n, onEnd);
            }
            return;
        }
        if (num <= 0 && isActive) {
            typeof onClick === 'function' && onClick();
        }
    }
    render() {
        const { children, isActive, type } = this.props;
        const { num } = this.state;
        return <div className={`count-btn${num <= 0 && isActive ? ' active' : ''} ${type ? type : ''}`}>
            <button className="btn" onClick={this.click}>
                <React.Fragment>
                    {children}
                    {num ? <React.Fragment>（{num}s）</React.Fragment> : null}
                </React.Fragment>
            </button>
        </div>
    }
};


// WEBPACK FOOTER //
// ./src/components/account/countBtn.jsx